import { startsWithAny } from '@/utils/fp';
import { Subpaths } from '@/types/enums/paths';
import {
    PASSWORD_PROTECTED_PATHS,
    PRIVATE_PATHS,
    UNAVAILABLE_TO_LOGGED_IN_USERS_PATHS,
    PUBLIC_PATHS,
} from '@/utils/auth/paths';

export const determinePathType = (pathname: string) => {
    const isPublicPath = startsWithAny(PUBLIC_PATHS)(pathname);
    const isPasswordProtectedPath =
        startsWithAny(PASSWORD_PROTECTED_PATHS)(pathname) && !isPublicPath;
    const isPrivatePath = startsWithAny(PRIVATE_PATHS)(pathname) && !isPublicPath;
    const isUnavailableToLoggedInUsersPath =
        pathname === Subpaths.Home ||
        (startsWithAny(UNAVAILABLE_TO_LOGGED_IN_USERS_PATHS)(pathname) && !isPublicPath);
    const isNotRestrictedPath =
        !isPasswordProtectedPath && !isPrivatePath && !isUnavailableToLoggedInUsersPath;

    return {
        isPublicPath,
        isPasswordProtectedPath,
        isPrivatePath,
        isUnavailableToLoggedInUsersPath,
        isNotRestrictedPath,
    };
};
